import type { TOC } from '@ember/component/template-only';

// Renders only the outlet: the list lives in `routines/index`, so the detail and run routes can
// replace it instead of the parent template pinning the list on screen.
const RoutinesRouteTemplate: TOC<object> = <template>{{outlet}}</template>;

export default RoutinesRouteTemplate;
